import AccountInfoItem from '../AccountInfoItem/AccountInfoItem'
import './BankAccount.css'
import {currencyFormat} from "../../../utils/currencyFormat";

export default function BankAccount({ account, transferAccountItemsArgentina, transferAccountItemsDolars }) {
   const {accountCBU: cbu, accountAlias: alias, accountHolder: name, accountCUIT: cuit, accountType: type, accountBank: bank, accountNumber = null} = account
    if (accountNumber) {
        return (
            <article className='bank-account-container'>
                < AccountInfoItem headline={transferAccountItemsDolars.firstTitle} text={accountNumber} canCopy />
                < AccountInfoItem headline={transferAccountItemsDolars.secondTitle} text={name} />
                < AccountInfoItem headline={transferAccountItemsDolars.thirdTitle} text={currencyFormat(cuit)} />
                < AccountInfoItem headline={transferAccountItemsDolars.fourthTitle} text={type} />
                < AccountInfoItem headline={transferAccountItemsDolars.fifthTitle} text={bank} />
            </article>
        )
    }
   return (
      <article className='bank-account-container'>
         < AccountInfoItem headline={transferAccountItemsArgentina.firstTitle} text={cbu} canCopy />
         < AccountInfoItem headline={transferAccountItemsArgentina.secondTitle} text={alias} canCopy />
         < AccountInfoItem headline={transferAccountItemsArgentina.thirdTitle} text={name} />
         < AccountInfoItem headline={transferAccountItemsArgentina.fourthTitle} text={cuit} />
         < AccountInfoItem headline={transferAccountItemsArgentina.fifthTitle} text={type} />
         < AccountInfoItem headline={transferAccountItemsArgentina.sixthTitle} text={bank} />
      </article>
   )
}
